import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import PrimaryButton from 'components/primary-button'
import LinkButton from 'components/link-button'

import styles from './primary-button-responsive.css'

const PrimaryButtonResponsive = ({ label, disabled, onClick }) => (
  <div styleName="primary-button-responsive">
    <div styleName="mobile">
      <LinkButton disabled={disabled} label={label} onClick={onClick} />
    </div>
    <div styleName="tablet">
      <PrimaryButton disabled={disabled} label={label} onClick={onClick} />
    </div>
  </div>
)

PrimaryButtonResponsive.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
}

export default CSSModules(PrimaryButtonResponsive, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/primary-button-responsive/primary-button-responsive.js
 **/